var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('h1',{staticClass:"heading-title-1"},[_vm._v("Info")]),_c('div',{staticClass:"h-stack h-end"},[_c('button',{staticClass:"edit",on:{"click":function($event){return _vm.$router.push('/pricelist/item/edit/' + _vm.item._id)}}},[_vm._v(" Edit ")])]),_c('div',{staticClass:"card light mn"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"v-stack gap-3"},[_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Name:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Category:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.item.categoryMain)+" - "+_vm._s(_vm.item.categorySub)+" ")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Unit:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.item.unit)+" ")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Comment:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.item.comment)+" ")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Editable Price:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.item.editablePrice ? "Yes" : "No")+" ")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Editable Count:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.item.editableCount ? "Yes" : "No")+" ")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Owned:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.item.inHouse ? "Yes" : "No")+" ")])])])])]),(_vm.item.inHouse && _vm.item.categoryMain == 'TECHNIKA')?[(_vm.$store.state.accessLevel >= 9)?[_c('h1',{staticClass:"heading-title-1"},[_vm._v("Gear")]),_c('div',{staticClass:"h-stack h-end"},[_c('button',{staticClass:"add",on:{"click":function($event){return _vm.$router.push('/pricelist/gear/add/' + _vm.item._id)}}},[_vm._v(" Add ")])]),_c('Table',{attrs:{"items":_vm.item.gear,"columns":[
          {
            name: 'Date of Purchase',
            sort: 'date',
            path: ['dateOfPurchase'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Serial Number',
            sort: 'alphabet',
            path: ['serialNumber'],
          },
          {
            name: 'Store Description',
            sort: 'alphabet',
            path: ['storeDescription'],
          },
          {
            name: 'Cost',
            sort: 'numeric',
            path: ['value'],
            format: 'czk',
            formatType: 'currency',
          },
          {
            name: 'Description',
            sort: 'alphabet',
            path: ['description'],
          },
        ]},on:{"rowSelected":function($event){return _vm.$router.push('/pricelist/gear/edit/' + $event._id)}}})]:_vm._e(),(_vm.$store.state.accessLevel > 9)?[_c('h1',{staticClass:"heading-title-1"},[_vm._v("Revenue")]),_c('div',{staticClass:"card light"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"v-stack gap-3"},[_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("Cost:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.format.currency(_vm.totalCost))+" Kč")])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('div',{staticClass:"text-right"},[_vm._v("Revenue:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(_vm.totalRevenue))+" Kč ")])]),_c('div',{staticClass:"pane-horizontal gap-3",staticStyle:{"font-weight":"bold"}},[_c('div',{staticClass:"text-right"},[_vm._v("Balance:")]),_c('div',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.format.currency(_vm.totalBalance))+" Kč ")])])])])]),_c('Table',{attrs:{"items":_vm.gearInBudget,"css":'80px 1fr 1fr 60px 100px 100px',"columns":[
          {
            name: 'Date',
            sort: 'date',
            path: ['project', 'deadline'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Project',
            sort: 'alphabet',
            path: ['project', 'name'],
          },
          {
            name: 'Pricelist',
            sort: 'alphabet',
            path: ['pricelist', 'name'],
          },
          {
            name: 'Count',
            sort: 'numeric',
            path: ['item', 'count'],
          },
          {
            name: 'Price',
            sort: 'numeric',
            path: ['item', 'price'],
            format: 'czk',
            formatType: 'currency',
          },
          {
            name: 'Total',
            sort: 'numeric',
            path: ['item', 'totalPrice'],
            format: 'czk',
            formatType: 'currency',
            formatMap: (price) => Math.round(price),
          },
        ]}})]:_vm._e()]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }